import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, withKeys as _withKeys, withCtx as _withCtx, withModifiers as _withModifiers, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-90b972cc"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "subtitle" }, "绑定虚拟MFA", -1));
const _hoisted_2 = { class: "img-box" };
const _hoisted_3 = ["src"];
const _hoisted_4 = /*#__PURE__*/ _createTextVNode("立即验证");
import { ref, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import CloudTips from "@/components/CloudTips/index.vue";
import { useMFA } from "@/hooks/useMFA";
import { bindMFA } from "@/service/login";
import { useLogin } from "./hooks";
import { getQueryParam } from "@/utils";
export default /*#__PURE__*/ _defineComponent({
    name: 'BindMFA',
    setup(__props) {
        const { changeState } = useLogin();
        const router = useRouter();
        const route = useRoute();
        const { oauth_callback } = route.query;
        const redirect_url = getQueryParam("redirect_url");
        const { MFAForm, MFAData, MFARules, submit } = useMFA({
            needBind: true,
            is_login: true,
            redirect_url: redirect_url
        });
        const tipsText = "使用小程序/Google Authenticator（身份验证器）扫描以下二维码，获取6位验证码";
        const image = ref("");
        let redirectValue = "";
        watch(() => route.query, () => {
            const redirectParam = route.query.redirect;
            if (Array.isArray(redirectParam)) {
                // 如果是数组，取第一个值
                redirectValue = redirectParam[0] || null;
            }
            else {
                // 如果是 string 或 null，直接使用
                redirectValue = redirectParam;
            }
        }, { immediate: true });
        const submitHandle = () => {
            submit().then(() => {
                //跳转文档中心或体验中心
                if (oauth_callback) {
                    window.location.href = Array.isArray(oauth_callback)
                        ? oauth_callback[0] || ""
                        : oauth_callback;
                    return;
                }
                changeState("already");
                if (!redirect_url) {
                    router.push({ path: redirectValue || "/" });
                }
                else {
                    window.location.href = redirect_url;
                }
            });
        };
        const getImg = () => {
            bindMFA().then((res) => {
                image.value = res.data.qr_code;
            });
        };
        getImg();
        return (_ctx, _cache) => {
            const _component_el_input = _resolveComponent("el-input");
            const _component_el_form_item = _resolveComponent("el-form-item");
            const _component_el_form = _resolveComponent("el-form");
            const _component_el_button = _resolveComponent("el-button");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _hoisted_1,
                _createVNode(CloudTips, {
                    class: "neck-box",
                    text: tipsText
                }),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("img", {
                        src: image.value,
                        alt: ""
                    }, null, 8, _hoisted_3)
                ]),
                _createVNode(_component_el_form, {
                    ref_key: "MFAForm",
                    ref: MFAForm,
                    size: "large",
                    model: _unref(MFAData),
                    rules: _unref(MFARules),
                    onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => { }, ["prevent"]))
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { prop: "num" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                    modelValue: _unref(MFAData).num,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(MFAData).num) = $event)),
                                    placeholder: "请输入动态MFA码",
                                    onKeydown: _withKeys(submitHandle, ["enter"])
                                }, null, 8, ["modelValue", "onKeydown"])
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                }, 8, ["model", "rules"]),
                _createVNode(_component_el_button, {
                    size: "large",
                    type: "primary",
                    class: "login-btn",
                    onClick: submitHandle
                }, {
                    default: _withCtx(() => [
                        _hoisted_4
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
